import { SpinnerIcon } from '@phosphor-icons/react';
import { T, useGT } from 'gt-react';

interface PdfPreviewAsideProps {
  pdfBase64: string | null;
  isAwaitingRefresh?: boolean;
  isPreviewing: boolean;
  previewError: boolean;
  subheading?: string;
}

export function PdfPreviewAside({
  pdfBase64,
  isAwaitingRefresh = false,
  isPreviewing,
  previewError,
  subheading,
}: PdfPreviewAsideProps) {
  const gt = useGT();
  return (
    <aside className="hidden xl:flex w-[620px] shrink-0 flex-col border-l pl-4">
      <div className="mb-2 flex items-center gap-2 text-sm font-medium">
        <T context="pdf preview column heading">PDF preview</T>
        {subheading && (
          <span className="text-xs font-normal text-muted-foreground">
            {subheading}
          </span>
        )}
      </div>
      {pdfBase64 ? (
        <iframe
          title={gt('PDF attachment preview', {
            context: 'iframe title for PDF preview',
          })}
          src={`data:application/pdf;base64,${pdfBase64}`}
          className="min-h-0 flex-1 w-full rounded border bg-muted/30"
        />
      ) : (
        <div className="min-h-0 flex-1 flex items-center justify-center rounded border bg-muted/30 text-xs text-muted-foreground">
          {isAwaitingRefresh ? (
            <span className="inline-flex items-center gap-2">
              <SpinnerIcon className="h-4 w-4 animate-spin" />
              <T context="loading indicator on PDF preview, shown while bulk send dialog refreshes data">
                Refreshing latest data...
              </T>
            </span>
          ) : isPreviewing ? (
            <span className="inline-flex items-center gap-2">
              <SpinnerIcon className="h-4 w-4 animate-spin" />
              <T context="pdf preview loading state">Loading preview...</T>
            </span>
          ) : previewError ? (
            <T context="pdf preview error state">Failed to load preview</T>
          ) : null}
        </div>
      )}
    </aside>
  );
}
